<div class="card-box clearfix">
	<div id="schema-container" class="exposed-background">
		<object id="schema-svg" type="image/svg+xml"></object>
		<div id="js-minimap-container" style="display: none"> </div>
	</div>
</div>
